/** Босс повержен — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import type { FriendsResponse } from "@newfungame/contracts";
import { balanceV1 } from "@newfungame/engine";
import { useEffect, useState } from "preact/hooks";
import { BossDefeatedView } from "./view";
import { appStore, canShareToStory, registerWindow } from "../../../app";
import { actions } from "../actions";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    bossDefeated: { wave: number; coins: number };
  }
}

/**
 * Первый босс — повод позвать друга (ISSUE-136): награда обоим, когда он пройдёт свою волну. Ссылка-приглашение есть
 * только у аккаунта Telegram. Стартовый пакет здесь больше не предлагаем: он ждёт первого поражения.
 */
function useFirstBossInvite(wave: number): FriendsResponse | null {
  const telegram = typeof appStore.get().player?.player.telegramId === "number";
  const first = wave === balanceV1.waves.bossEvery;
  const [friends, setFriends] = useState<FriendsResponse | null>(null);
  useEffect(() => {
    if (!telegram || !first) return;
    void actions()
      .friends()
      .then(setFriends)
      .catch(() => {
        // без приглашения окно остаётся прежним
      });
  }, [telegram, first]);
  return friends?.inviteUrl ? friends : null;
}

export function BossDefeated({ route, close }: WindowProps<"bossDefeated">) {
  const tg = appStore.get().miniApp ? window.Telegram?.WebApp : null;
  const invite = useFirstBossInvite(route.wave);
  return (
    <BossDefeatedView
      wave={route.wave}
      coins={route.coins}
      invite={invite ? (invite.reward ?? {}) : null}
      onInvite={() => invite?.inviteUrl && actions().inviteFriend(invite.inviteUrl, "boss")}
      onNext={() => {
        actions().nextWave();
        close();
      }}
      onShare={() => actions().share({ wave: route.wave })}
      {...(tg && canShareToStory(tg) ? { onStory: () => actions().share({ wave: route.wave, target: "story" }) } : {})}
    />
  );
}

export function register(): void {
  registerWindow("bossDefeated", BossDefeated);
}
